import { render } from "./TabMediaEditor.vue?vue&type=template&id=11333489&scoped=true"
import script from "./TabMediaEditor.vue?vue&type=script&scoped=true&lang=js"
export * from "./TabMediaEditor.vue?vue&type=script&scoped=true&lang=js"

import "./TabMediaEditor.vue?vue&type=style&index=0&id=11333489&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11333489"]])

export default __exports__